import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Optional } from '@angular/core'
import { OPERATORS } from 'src/app/services/constants';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss']
})
export class CustomTooltipComponent implements OnInit {
  @Input() metadata: any;
  @Input() product: any;
  @Input() operator: any;
  @Input() refreshDataType: any;
  operators: any;

  constructor(@Optional() private dialogRef: MatDialogRef<CustomTooltipComponent>) {
    this.operators = OPERATORS;
   }

  ngOnInit(): void {
  }

  getObjectEntries(obj: any): any[] {
    if (obj != null)
    return Object.entries(obj);
    else return [];
  }

  formatKey(key: string): string {
    return key.replace(/_/g, ' ').replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }

  get metadataItems(): string[] {
    const md = this.metadata;
    if (typeof md === 'string') {
      if (md.includes(';')) {
        return md.split(';').map(i => i.trim());
      } else {
        return [md.trim()];
      }
    }
    return [];
  }
 closeplanUpgrade() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
